/**
 * This file contains type definitions for permission management.
 * These are simple classes to serve as models for the frontend,
 * and you can expand them as needed.
 */

/**
 * Represents a permission group.
 */
export class PermissionGroup {
  constructor({ group_id, name, description, created_at, updated_at }) {
    this.group_id = group_id;
    this.name = name;
    this.description = description;
    this.created_at = created_at;
    this.updated_at = updated_at;
  }

  static fromApiResponse(data) {
    return new PermissionGroup(data);
  }
}

/**
 * Represents a user-to-group mapping.
 */
export class UserGroup {
  constructor({ user_id, group_id, created_at }) {
    this.user_id = user_id;
    this.group_id = group_id;
    this.created_at = created_at;
  }

  static fromApiResponse(data) {
    return new UserGroup(data);
  }
}

/**
 * Represents plugin access assigned to a group.
 */
export class PluginAccess {
  constructor({ plugin_id, group_id, created_at }) {
    this.plugin_id = plugin_id;
    this.group_id = group_id;
    this.created_at = created_at;
  }

  static fromApiResponse(data) {
    return new PluginAccess(data);
  }
}

/**
 * Represents an individual override for plugin access.
 */
export class PluginUserAccess {
  constructor({ plugin_id, user_id, granted, created_at }) {
    this.plugin_id = plugin_id;
    this.user_id = user_id;
    this.granted = granted;
    this.created_at = created_at;
  }

  static fromApiResponse(data) {
    return new PluginUserAccess(data);
  }
}

/**
 * Represents an access request from a user.
 */
export class AccessRequest {
  constructor({ request_id, user_id, plugin_id, message, status, created_at, updated_at, processed_by, processed_at }) {
    this.request_id = request_id;
    this.user_id = user_id;
    this.plugin_id = plugin_id;
    this.message = message;
    this.status = status;
    this.created_at = created_at;
    this.updated_at = updated_at;
    this.processed_by = processed_by;
    this.processed_at = processed_at;
  }

  static fromApiResponse(data) {
    return new AccessRequest(data);
  }
}